export const getCurrencyDisplayLabel = (currency) => {
  if (!currency || currency === 'TRY') return 'TL';
  return currency;
};

export const normalizeCurrencyInput = (value) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  const upper = trimmed.toUpperCase();
  if (upper === 'TL' || upper === 'TRY') return 'TRY';
  return upper;
};

export const formatMoneyWithCurrency = (amount, currency = 'TRY') => {
  if (amount == null || Number.isNaN(Number(amount))) return '-';
  const formatted = Number(amount).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${getCurrencyDisplayLabel(currency)}`;
};
